module.exports = __webpack_public_path__ + "img/home.cd55df06.svg";